'use client'

import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import * as React from 'react'

import { Button } from '@/components/ui/button'

export function PublicShareAuthDock() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const returnTo = React.useMemo(() => {
    const path = String(pathname || '/')
    const query = searchParams.toString()
    return query ? `${path}?${query}` : path
  }, [pathname, searchParams])
  const signupHref = `/signup?return_to=${encodeURIComponent(returnTo)}`

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-5 z-[120] flex justify-center px-4">
      <div className="pointer-events-auto flex items-center gap-2 rounded-full border border-border/70 bg-background/90 p-1.5 pl-2.5 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/75">
        <Link href="/" className="flex h-8 w-8 shrink-0 items-center justify-center" aria-label="FastFold home">
          <img src="/ff_simbol_color.svg" alt="" className="h-[22px] w-[22px]" />
        </Link>
        <Button asChild className="h-10 rounded-full px-5 shadow-none">
          <Link href={signupHref}>Sign up</Link>
        </Button>
        <Button asChild variant="ghost" className="h-10 rounded-full px-4">
          <Link href="/apps">Explore apps</Link>
        </Button>
      </div>
    </div>
  )
}
